// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_c3-b";
export var colorBlue = "_c3-8";
export var colorDot = "_c3-0";
export var colorDotLarge = "_c3-2";
export var colorDotSmall = "_c3-1";
export var colorGreen = "_c3-7";
export var colorGrey = "_c3-3";
export var colorOrange = "_c3-5";
export var colorPink = "_c3-a";
export var colorPurple = "_c3-9";
export var colorRed = "_c3-4";
export var colorYellow = "_c3-6";